// extracted by mini-css-extract-plugin
export default {"SideBarItemWrapper":"SideBarItem_SideBarItemWrapper__OETV1","title":"SideBarItem_title__zuhDD","NavLink":"SideBarItem_NavLink__7iZsF"};